import isAfter from './is-after';

export { isAfter };

export default isAfter;
